import React from 'react';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import customStyles from 'page_modules/compare/__styles__/attributesTable.scss?modules';

const AttrRowHeader = ({ header, tag }) => {
  return (
    <div className={customStyles.rowHeader}>
      <Sanitizer Component="span" safelySetInnerHTML={header || ''} />
      {tag && (
        <Sanitizer className={customStyles.flag} safelySetInnerHTML={tag || ''} />
      )}
    </div>
  );
};

export default React.memo(AttrRowHeader);
